export default "__VITE_ASSET__c5854688__"